import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="criterion-period-form"
export default class extends Controller {

	static targets = [
		'requirementType',
		'count',
		'countInput',
		'duration',
		'durationInput',
	]

	static values = {
	}

	connect() { this.updateLayout() }

	updateLayout(_event) {
		switch (this.requirementTypeTarget.value) {
			case 'all_goals':
				this.hideCount()
				this.hideDuration()
				break;

			case 'goal_count':
				this.showCount()
				this.hideDuration()
				break;

			case 'attended_activity_duration':
				this.hideCount()
				this.showDuration()
				break;

			case 'facilitated_activity_duration':
				this.hideCount()
				this.showDuration()
				break;

			default:
				this.hideCount()
				this.hideDuration()
				break;
		}
	}

	showCount() {
		this.countTarget.classList.remove('d-none')
		this.countInputTarget.disabled = false
	}

	hideCount() {
		this.countTarget.classList.add('d-none')
		this.countInputTarget.disabled = true
	}

	showDuration() {
		this.durationTarget.classList.remove('d-none')
		this.durationInputTarget.disabled = false
	}

	hideDuration() {
		this.durationTarget.classList.add('d-none')
		this.durationInputTarget.disabled = true
	}
}
